/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext } from 'react';
import {
	IconButton,
	Menu,
	MenuItem,
	Typography,
	Box,
	ListItemIcon,
	Divider
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {
	PROJECTS,
	SHARED,
	MAX_SAVE_DRAFT,
	SAVED_RPT_MSG,
	PERSONA,
	BASIC,
	FILTER_CONDITION_LABELS,
	EDIT,
	REPORT,
	STR_DEMAND_LIST,
	MULTI_TIME_SELECTION,
	WALMART_CALENDAR,
	CATMAN_CUSTOM_DATASET_IDS,
	INACTIVE,
	PREVIEW_LOADING_MSG,
	NETWORK_ISSUE_MSG,
	GENERAL_CANNED_REPORT_LIST
} from 'constants/constant';
import dashboardStyles from '../Dashboard.style';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from 'context/appcontext';
import { deepClone } from 'helper/helper';
import { reportMenu, getSelectedList } from './utils/report';
import {
	setSelectedList,
	setPrevSelectedList,
	setPrevFilterList,
	loadPreviewData,
	setFilterList,
	saveItemShareStatus
} from 'components/Preview/Preview.actions';
import {
	initiateRunNow,
	editReport,
	leaveReport,
	getSavedReportsListSuccess
} from '../Dashboard.actions';
import {
	setSelectedTemplate,
	getTempatesSuccess,
	getTempatesFailure,
	getCustomAttributeSuccess,
	getCustomAttributeFailure,
	setCustomDatasetName,
	getCannedReportsSuccess
} from 'components/Template/Template.actions';
import { useNavigate } from 'react-router-dom';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import { selectedTempDetials } from './utils/dashboard-utils';
import { FEATURES } from 'helper/basicFeatureFlag';
import DialogBox from 'components/Shared/DialogBox';
import { postData } from 'service/postData.service';
import APIURLPATH from 'constants/apiconstants';
import { getReportMenuListItem, getSharedReportMenuListItem } from './MenuListItem';
import { getData } from 'service/getData.service';
import DeleteDialog from '../delete-dialog/DeleteDialog';
import { getDfltFilter, getSavedCustomDatasetWithAttributes } from 'helper/utils';
import { build } from 'helper/build';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {
	getUpdatedFilters,
	getSelectedView,
	updateDtObj,
	hasPivotedColumn
} from 'components/Preview/Preview.utils';
import ItemShareTnCDialog from '../../Shared/ItemShareTnCDialog';
import { isMultiWeekSel } from 'components/Preview/filter/FilterCondition';

function MenuList(props) {
	const navigate = useNavigate();
	// eslint-disable-next-line prettier/prettier
	const { index, handleDownload, handleShareReport, rowData, callReportSaved } = props;
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, updateUserPersona, customerType, isItemShareAccepted } = portalUserContext;
	const { companyName, loginId, userPersona, blackOut } = userDetails?.result;
	const request = { companyName, loginId };
	const classes = dashboardStyles();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const [openRenameDailog, setOpenRenameDialog] = useState(false);
	const [openDeleteDialog, setOpenDialogDelete] = useState(false);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const savedReportsList = useSelector((state) => state.dashboardReducer.savedReportsList);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const tabValue = useSelector((state) => state.dashboardReducer.tabValue);
	const isSharingEnabled = useSelector((state) => state.dashboardReducer.isSharingEnabled);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const sharedReportTabValue = useSelector((state) => state.dashboardReducer.sharedReportTabValue);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);

	// eslint-disable-next-line prettier/prettier
	const { DISABLE_CONTEXT_SHARE: disableShare, DISABLE_CONTEXT_RUN_NOW: disableRunNow } =
		FEATURES[customerType].DASHBOARD;
	const reportMenuList = getReportMenuListItem();
	const sharedReportMenuList = getSharedReportMenuListItem();
	const { SUPPLIER, CATMAN } = PERSONA;
	const [openTnC, setOpenTnC] = useState({ open: false, clickOn: '' });

	const handleOpen = (event) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (event) => {
		event.stopPropagation();
		setAnchorEl(null);
	};

	const handleRunNow = (event) => {
		dispatch(initiateRunNow({ requestBody: event.reportId, companyName }));
	};

	const skipTour = () => {
		localStorage.setItem('PreviewComponentTourSkip', true);
		localStorage.setItem('PreviewElementTourSkip', true);
		localStorage.setItem('FilterFormTourSkip', true);
	};

	const handleEdit = (data) => {
		// stopPropagation(e);
		// setAnchorEl(null);

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.EDIT_REPORT_BUTTON} ${data?.templateName}`,
			location: PAGE_ID.DASHBOARD
		});

		callReportSaved({
			open: true,
			msg: PREVIEW_LOADING_MSG,
			type: 'success',
			hideDuration: 5000
		});

		navigateToPreview(data);
		skipTour();
	};

	const navigateToPreview = async (_d) => {
		let templateId = undefined;
		let selectedTemp = undefined;

		if (userPersona === CATMAN && _d.reportType === SUPPLIER) {
			const isCannedReport = GENERAL_CANNED_REPORT_LIST.includes(Number(_d.templateId));
			let url = isCannedReport
				? `${APIURLPATH.CANNED_TEMPLATES}SUPPLIER`
				: `${APIURLPATH.VIEW_TYPE}SUPPLIER`;
			let customUrl = `${APIURLPATH.CUSTOM_ATTRIBUTES_TYPE}SUPPLIER`;

			const request = { companyName, loginId };
			const response = await getData(url, request);
			const customResponse = await getData(customUrl, request);
			if (response?.statusCode >= 400 || customResponse?.statusCode >= 400) {
				dispatch(getTempatesFailure(505));
				dispatch(getCustomAttributeFailure(505));
				callReportSaved({
					open: true,
					msg: NETWORK_ISSUE_MSG,
					type: 'error',
					hideDuration: 5000
				});
				return;
			} else {
				let res = await response?.json;
				let customRes = await customResponse?.json;
				updateUserPersona(_d.reportType);
				if (isCannedReport) {
					dispatch(getCannedReportsSuccess(res));
				} else {
					dispatch(getCustomAttributeSuccess(customRes));
					dispatch(getTempatesSuccess(res));
				}
				res = res.map((item) => {
					if (isCannedReport) {
						return item;
					}
					return {
						...item,
						customAttribute: customRes
					};
				});
				nextSteps(res);
			}
		} else {
			nextSteps(templateData);
		}

		function nextSteps(tempData) {
			const _isItemShare = _d.runQueryRequestObject.itemShare || false;

			const savedCustomDatasetWithAttributes = getSavedCustomDatasetWithAttributes(
				savedCustomDatasets,
				customDatasetDetails,
				customAttribute
			);
			const tmpData = [...cannedReportData, ...tempData, ...savedCustomDatasetWithAttributes];
			const potentialTempList = tmpData.filter((item) => {
				const isCatmanCustomDS =
					CATMAN_CUSTOM_DATASET_IDS.includes(Number(_d.templateId)) && userPersona === CATMAN;
				if (isCatmanCustomDS || _d.templateId === customDatasetDetails.templateId) {
					return _d?.customDatasetId === item?.customDatasetId;
				} else {
					return item.templateName === _d.templateName;
				}
			});
			const tempWithSameId = potentialTempList.find((temp) => temp.templateId === _d.templateId);
			selectedTemp = tempWithSameId ? tempWithSameId : potentialTempList[0];
			dispatch(setCustomDatasetName({ datasetName: selectedTemp.customDatasetName }));

			templateId = selectedTemp?.templateId;
			let appliedFilter = _d?.filtersWithValue.filter((item) => {
				// In MTS, there is a chance that the condition is empty but the custom dates are filled, in this case,
				// we would want the filter
				if (item?.localName === MULTI_TIME_SELECTION) {
					return true;
				}
				return item.filter.condition !== '';
			});

			/**
			 * if template is demand forecast
			 * find isCalObj and store in diff variable (say _o)
			 * filter appliedFilter and remove isCalObj
			 * Update - field and filter object - call getLastXWkRange
			 * pushing _o in appliedFilter
			 */

			if (STR_DEMAND_LIST.includes(Number(templateId))) {
				appliedFilter = updateDtObj(appliedFilter);
			}

			if (tabValue === SHARED && _d?.reportType !== userPersona) {
				appliedFilter = getUpdatedFilters(appliedFilter, templateId, selectedTemp, userPersona);
			}

			if (userPersona === 'MERCHANT' && !blackOut) {
				if (!appliedFilter.find((item) => sbuDBTechNames.includes(item.dbtechnicalName))) {
					const SBUdimension = selectedTemp.dimensions.filter((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);

					const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;

					const dfltFiltersOnDimensions = [];
					SBUdimension.map((dim) => {
						dfltFiltersOnDimensions.push({
							dimension: dim,
							condition: SBUDfltCondition,
							value: sbuDepartments.map((dept) => dept.deptNum)
						});
					});
					const defaultFilterSel = getDfltFilter(templateData, dfltFiltersOnDimensions);

					defaultFilterSel.map((filter, index) => {
						if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
							const field = build(defaultFilterSel[index], selectedView, userPersona);
							defaultFilterSel[index] = { ...defaultFilterSel[index], field };
							appliedFilter.push(defaultFilterSel[index]);
						}
					});
				}
			}

			const selectedList = getSelectedList(_d, tmpData, templateId);
			const req = deepClone(_d.runQueryRequestObject);

			if (_d?.pivotColumn && hasPivotedColumn(_d?.pivotColumn)) {
				/**
				 * For Pivot on Walmart Calendar Week,
				 * - If multi week filter is not applied, pivotColumn should corrected to the technicalName(walmart_calendar_week/walmart_year_and_week).
				 * - If multi week filter is applied, isMultiWeek should be true.
				 */
				const wmtCalWeeks = ['walmart_calendar_week', 'walmart_year_and_week'];
				const weekFilterApplied = _d?.filtersWithValue?.find(
					(e) => wmtCalWeeks.includes(e?.technicalName) && e?.parent === WALMART_CALENDAR
				);
				if (weekFilterApplied) {
					// _d.pivotColumn = isMTS(weekFilterApplied)
					// 	? _d.pivotColumn
					// 	: weekFilterApplied?.technicalName;
					_d.isMultiWeek = isMultiWeekSel(weekFilterApplied, Number(templateId));
				}
			}

			dispatch(
				loadPreviewData({
					requestBody: req,
					editData: _d
				})
			);
			let updatedSelectedView = _d.runQueryRequestObject.view;
			if (tabValue === SHARED && _d?.reportType !== userPersona) {
				updatedSelectedView = getSelectedView(appliedFilter, templateId, selectedTemp);
			}
			dispatch(setSelectedTemplate(selectedTempDetials(updatedSelectedView, selectedTemp)));
			dispatch(editReport({ isEditEnabled: true, editData: _d, action: 'EDIT' }));
			dispatch(setSelectedList(selectedList));
			dispatch(setPrevSelectedList(selectedList));
			dispatch(setFilterList(appliedFilter));
			dispatch(setPrevFilterList(appliedFilter));
			dispatch(saveItemShareStatus({ prev: _isItemShare, curr: _isItemShare }));
			dispatch(getTempatesSuccess(tmpData));
			navigate('/preview');
		}
	};

	const handleCreateToSaved = (_d) => {
		const isSaved = savedReportsList.some((_i) => _i.draftName === _d.reportName);
		if (isSaved) {
			setOpenRenameDialog(true);
			return;
		}
		if (savedReportsList.length >= MAX_SAVE_DRAFT) {
			callReportSaved({
				open: true,
				msg: SAVED_RPT_MSG.LIMIT_EXCEED,
				type: 'error'
			});
			return;
		}

		callSaveApi(_d);
	};

	const callSaveApi = async (_d) => {
		const draftParam = {
			..._d,
			draftId: '',
			draftName: _d.reportName
		};

		delete draftParam.reportId;
		delete draftParam.reportName;

		const URL = APIURLPATH.SAVE_DRAFT;
		request['requestBody'] = draftParam;
		const status = await postData(URL, request);
		if (status.statusCode >= 400) {
			callReportSaved({
				open: true,
				msg: SAVED_RPT_MSG.SAVING_FAILED,
				type: 'error'
			});
			setOpenRenameDialog(false);
			return;
		}

		let list = deepClone(savedReportsList);
		list.unshift(status?.json);
		dispatch(getSavedReportsListSuccess(list));

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.SAVE_REPORT_FROM_DASHBOARD} ${_d?.templateName}`,
			location: PAGE_ID.DASHBOARD
		});

		callReportSaved({ open: true, msg: SAVED_RPT_MSG.REPORT_ADDED, type: 'success' });
	};

	const RenameDialog = () => {
		if (!openRenameDailog) {
			return <div />;
		}
		const dialogProps = {
			title: 'Name already exists',
			bodyContent: 'Please give your saved report a unique name. ',
			secondaryBtnText: 'Cancel',
			primaryBtnText: 'Save',
			onSecondaryClick: () => {
				setOpenRenameDialog(false);
			},
			onPrimaryClick: callRename,
			showTextBox: true,
			defaultTxtValue: rowData.reportName
		};

		return <DialogBox open={openRenameDailog} {...dialogProps} />;
	};

	const callRename = async (newRptName) => {
		const d = deepClone(rowData);
		d.reportName = newRptName;
		d.reportId = '';
		callSaveApi(d);
		setOpenRenameDialog(false);
	};

	const handleLeaveReport = (data) => {
		const id = data?.reportId;
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.LEAVE_REPORT,
			location: PAGE_ID.DASHBOARD
		});
		dispatch(leaveReport({ reportId: id, loginId, companyName }));
	};

	const shouldShowMenuOption = (item) => {
		let optionVisible = true;
		switch (item.id) {
			case 'run_again':
				optionVisible = customerType === BASIC && rowData.status === 'FAILED';
				break;
			case 'download':
			case 'add_to_saved':
				optionVisible = !(tabValue === SHARED && sharedReportTabValue === 1);
				break;
		}
		return optionVisible;
	};

	const shouldDisableOption = (id) => {
		const isCustomDS =
			rowData?.templateId === customDatasetDetails?.templateId ||
			CATMAN_CUSTOM_DATASET_IDS.includes(Number(rowData?.templateId)) ||
			rowData?.customDatasetId?.length > 0;
		switch (id) {
			case 'edit': {
				return reportMenu(rowData, customerType, tabValue, isCustomDS).isEditDisabled;
			}
			case 'download': {
				return reportMenu(rowData, customerType, tabValue, isCustomDS).isDownloadDisabled;
			}
			case 'share': {
				return (
					reportMenu(rowData, customerType, tabValue, isCustomDS).isSharingDisabled ||
					!isSharingEnabled
				);
			}
			case 'run_now': {
				return (
					reportMenu(rowData, customerType, tabValue, isCustomDS).isRunNowDisabled ||
					rowData.status === INACTIVE
				);
			}
			case 'add_to_saved': {
				return reportMenu(rowData, customerType, tabValue, isCustomDS).isAddToSavedDisabled;
			}
			default: {
				return false;
			}
		}
	};

	const handleOnClick = (id, rowData) => {
		const fn = {
			edit: () => {
				if (
					tabValue === SHARED &&
					!isItemShareAccepted &&
					rowData.runQueryRequestObject?.itemShare
				) {
					setOpenTnC({ open: true, clickOn: 'EDIT' });
					return;
				}
				handleEdit(rowData);
			},
			add_to_saved: () => {
				handleCreateToSaved(rowData);
			},
			download: () => {
				if (
					tabValue === SHARED &&
					!isItemShareAccepted &&
					rowData.runQueryRequestObject?.itemShare
				) {
					setOpenTnC({ open: true, clickOn: 'DOWNLOAD' });
					return;
				}
				handleDownload(rowData, index);
			},
			share: () => {
				handleShareReport(rowData);
			},
			delete: () => {
				setOpenDialogDelete(true);
			},
			run_again: () => {
				handleRunNow(rowData);
			},
			run_now: () => {
				handleRunNow(rowData);
			},
			leave_report: () => {
				handleLeaveReport(rowData);
			}
		};
		return fn[id]();
	};

	const getOptionName = (item) => {
		if (item.id === 'download') {
			return tabValue === PROJECTS && rowData.downloadCount > 0 ? item.alternetName : item.name;
		}
		if (item.id === 'edit') {
			if (tabValue === SHARED && sharedReportTabValue === 1) {
				return `${EDIT} & ${REPORT.toLowerCase()}`;
			}
		}
		return item.name;
	};

	const renderChartedOnlyTag = (item) => {
		if (customerType === BASIC) {
			if ((item.id === 'share' && disableShare) || (item.id === 'run_now' && disableRunNow)) {
				return <LockOutlinedIcon className={classes.charterOnly} />;
			}
		}
		return null;
	};

	const renderOptions = (val) => {
		const o = {
			[PROJECTS]: reportMenuList,
			[SHARED]: sharedReportMenuList
		};
		const list = o[val];

		return list.map((item) => {
			if (shouldShowMenuOption(item)) {
				return (
					<Box key={`${item.id}-${index}`}>
						{item.divider && <Divider />}
						<MenuItem
							id={`${item.id}-${index}`}
							disabled={shouldDisableOption(item.id)}
							className={classes.menuItems}
							onClick={(e) => {
								e.stopPropagation();
								setAnchorEl(null);
								handleOnClick(item.id, rowData);
							}}>
							<ListItemIcon>{item.icon}</ListItemIcon>
							<Typography>{getOptionName(item)}</Typography>
							{renderChartedOnlyTag(item)}
						</MenuItem>
					</Box>
				);
			}
		});
	};

	return (
		<>
			<IconButton id={`toolbar-options-${index}`} onClick={handleOpen}>
				<MoreVertIcon fontSize="medium" />
			</IconButton>
			<Menu
				id={`action-items-${index}`}
				anchorEl={anchorEl}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				className={classes.menu}
				elevation={1}
				MenuListProps={{
					'aria-labelledby': 'basic-button'
				}}
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				{renderOptions(tabValue)}
			</Menu>

			<RenameDialog />
			<DeleteDialog
				open={openDeleteDialog}
				onClose={() => {
					setOpenDialogDelete(false);
				}}
				selectedRow={rowData}
			/>

			<ItemShareTnCDialog
				open={openTnC.open}
				onClose={({ status, otherProps }) => {
					setOpenTnC(false);
					if (status === 'ACCEPTED') {
						if (otherProps === 'EDIT') {
							handleEdit(rowData);
						}

						if (otherProps === 'DOWNLOAD') {
							handleDownload(rowData);
						}
					}
				}}
				otherProps={openTnC.clickOn}
			/>
		</>
	);
}

export default MenuList;
